import { GameAsset } from '../../services/asset-catalogue-service';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { PileView } from './pile-view';
import { FoundationPileViewModel } from './foundation-pile-view-model';
import { DragData } from './board-view-model';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class FoundationPileView extends PileView {
  private get foundationViewModel(): FoundationPileViewModel {
    return this.viewModel as FoundationPileViewModel;
  }

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: FoundationPileViewModel) {
    super(scene, x, y, viewModel);
  }

  public handleCardDragEnd(dragData: DragData) {
    const rect = this.background.getBounds();
    if (rect.contains(dragData.dragX, dragData.dragY)) {
      this.foundationViewModel.droppedOver(dragData.cardViewModel);
    }
  }

  protected override resizeBackground(
    gameSizeMetrics: GameSizeMetrics,
    gameAsset: GameAsset,
  ): void {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    let xPos = (gameSizeMetrics.widthDpr - calc.totalWidth * calc.scaleFactor) * 0.5;
    xPos +=
      this.foundationViewModel.index *
      ((gameAsset.dimensions.width + layoutConfig.hSpacing) * calc.scaleFactor);
    const yPos = layoutConfig.vPadding * calc.scaleFactor;

    this.background.setPosition(xPos, yPos);
    this.background.setDisplaySize(
      gameAsset.dimensions.width * calc.scaleFactor,
      gameAsset.dimensions.height * calc.scaleFactor,
    );
  }
}
